import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationRejectModel = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to Reject?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Reject
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationRejectModel;
